export const DISH_CATEGORY_GET_REQUEST = 'DISH_CATEGORY_GET_REQUEST';
export const DISH_CATEGORY_GET_SUCCESS = 'DISH_CATEGORY_GET_SUCCESS';
export const DISH_CATEGORY_GET_FAILURE = 'DISH_CATEGORY_GET_FAILURE';

export const DISH_CATEGORY_GET_BY_ID_REQUEST = 'DISH_CATEGORY_GET_BY_ID_REQUEST';
export const DISH_CATEGORY_GET_BY_ID_SUCCESS = 'DISH_CATEGORY_GET_BY_ID_SUCCESS';
export const DISH_CATEGORY_GET_BY_ID_FAILURE = 'DISH_CATEGORY_GET_BY_ID_FAILURE';

export const DISH_CATEGORY_CREATE_OR_UPDATE_REQUEST = 'DISH_CATEGORY_CREATE_OR_UPDATE_REQUEST';
export const DISH_CATEGORY_CREATE_OR_UPDATE_SUCCESS = 'DISH_CATEGORY_CREATE_OR_UPDATE_SUCCESS';
export const DISH_CATEGORY_CREATE_OR_UPDATE_FAILURE = 'DISH_CATEGORY_CREATE_OR_UPDATE_FAILURE';

export const DISH_CATEGORY_DELETE_REQUEST = 'DISH_CATEGORY_DELETE_REQUEST';
export const DISH_CATEGORY_DELETE_SUCCESS = 'DISH_CATEGORY_DELETE_SUCCESS';
export const DISH_CATEGORY_DELETE_FAILURE = 'DISH_CATEGORY_DELETE_FAILURE';

export const RESET_DISH_CATEGORY_ERRORS = 'RESET_DISHES_ERRORS';

export const CHANGE_DISH_CATEGORY_FORM_STEP = 'CHANGE_DISH_CATEGORY_FORM_STEP';

export const RESET_DISH_CATEGORY_LIST_DATA = 'RESET_DISH_CATEGORY_LIST_DATA';
export const DISH_CATEGORY_CHANGE_POSITION_REQUEST = 'DISH_CATEGORY_CHANGE_POSITION_REQUEST';
export const DISH_CATEGORY_CHANGE_POSITION_SUCCESS = 'DISH_CATEGORY_CHANGE_POSITION_SUCCESS';